import { mediumCommandBarDensity } from '../components/commandbar/mediumCommandBar';
import { fullCommandBarDensity } from '../components/commandbar/fullCommandBar';
import { compactCommandBarDensity } from '../components/commandbar/compactCommandBar';
import type { PartialTheme } from '@fluentui/theme';

export function getCommandBarTheme(densityModeString: string): PartialTheme {
    if (densityModeString === 'compact') {
        return compactCommandBarDensity;
    } else if (densityModeString === 'medium') {
        return mediumCommandBarDensity;
    } else {
        return fullCommandBarDensity;
    }
}

export function getNewMessageButtonTheme(densityModeString: string): PartialTheme {
    if (densityModeString === 'compact') {
        return newMessageButtonMargin('4px');
    } else if (densityModeString === 'medium') {
        return newMessageButtonMargin('6px');
    } else {
        return newMessageButtonMargin('8px');
    }
}

const newMessageButtonMargin = (marginRight: string) => {
    return {
        components: {
            CommandBarButton: {
                styles: { root: { margin: '6px ' + marginRight + ' 6px 12px' } },
            },
        },
    };
};
